import React from 'react';
import { Popup, Icon, Button } from 'semantic-ui-react';
import { Link } from 'react-router';
import DOMPurify from 'dompurify';

const AmsPopup = ({
  content,
  label,
  type,
  style,
  dangerouslySetInnerHTML = false,
}) => {
  const triggerButton = (
    <Button content={label} style={style} aria-label={label} tabIndex={0} />
  );

  const triggerIcon = (
    <Link
      href="#"
      onClick={e => e.preventDefault()}
      tabIndex={0}
      role="button"
      aria-describedby="tooltip-content"
      aria-label={`Tooltip info: ${content}`}
      style={{ color: '#000000', textDecoration: 'none' }}
    >
      <Icon name={label} size="large" />
    </Link>
  );

  return (
    <Popup
      trigger={type === 'Button' ? triggerButton : triggerIcon}
      size="small"
      position="top center"
      on={['click', 'hover', 'focus']}
      role="tooltip"
      id="tooltip-content"
    >
      <Popup.Content>
        {dangerouslySetInnerHTML ? (
          <div
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
          />
        ) : (
          content
        )}
      </Popup.Content>
    </Popup>
  );
};
export default AmsPopup;
